var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "assistant-lp-stores" }, [
      _c("span", {}, [
        _vm._v(_vm._s(_vm._f("trans")("st_public.Download Now")))
      ]),
      _c("div", { staticClass: "d-flex", staticStyle: { gap: "15px" } }, [
        _c(
          "a",
          {
            attrs: { target: "_blank", href: _vm.deeplink },
            on: {
              click: function($event) {
                return _vm.updateDeeplinkFrom("ASSISTANT_DEEPLINK_1")
              }
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("assets/assistant/google-play.svg"),
                alt: ""
              }
            })
          ]
        ),
        _c(
          "a",
          {
            attrs: { target: "_blank", href: _vm.deeplink },
            on: {
              click: function($event) {
                return _vm.updateDeeplinkFrom("ASSISTANT_DEEPLINK_2")
              }
            }
          },
          [
            _c("img", {
              attrs: { src: require("assets/assistant/itunes.svg"), alt: "" }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a4a4f62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a4a4f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/assistant/AssistantStore.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3a4a4f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/assistant/AssistantStore.vue
// module chunks = 10